import { GiftCard } from '@package/core/src/giftCard/types';
import { DiscountErrorState, DiscountErrorType } from '@package/core/src/shoppingCart/types';

export type GiftCardFormProps = {
  id: string;
  fullWidth?: boolean;
  buttonLabel: string;
  onFocus?: React.FocusEventHandler;
  onBlur?: React.FocusEventHandler;
  giftCardError?: DiscountErrorState;
  giftCards?: Array<GiftCard>;
  removeGiftCardError?: (discountErrorType: DiscountErrorType) => void;
  onDelete: ({ serialNumber }: { serialNumber: string }) => void;
};

export const BBMESSAGE =
  'For this Gift Card, please use the Bullseye Bucks Redemption module <span class="alink">learn more</span>';
